var $ = require('jquery');
var ajax = require('../core/ajax');
var bootstrap = require('../bootstrap/index');
var pop = bootstrap.BootstrapDialog;

/**
 *  文件上传：写死文件上传接口，后台会通过ngnix转发至相应的文件服务器
 * @param options 类型可Object、表单DOM节点。为Object时，按照字段说明取值，否则直接取表单DOM中的数据
 */
function uploadFile(options) {
    var toStringFn = Object.prototype.toString;
    var formData;
    var $temp = $(options);
    var additionOne = toStringFn.call($temp)==='[object Object]' && toStringFn.call($temp.context)==='[object HTMLDocument]'; // DOM节点场景1：传进的是多节点的情况
    var additionTwo = toStringFn.call($temp)==='[object String]'; // 传入的DOM节点的类、id等字符串
    var isDom = additionTwo || additionOne; // options为DOM节点或者字符串时
    if(isDom) { // options为DOM节点或者字符串时
        formData = handle($temp, formData);
    } else { // options为Object对象时
        options = $.extend(true, {}, {
            $form: null, // 表单的DOM节点
            formData: null, // 存在表单DOM节点时优先取DOM节点数据，没有DOM节点时取formData数据
            needCallback: false, // 是否需要回调函数做处理
            callback: $.noop, // 回调函数
        }, options);
        if(!options.$form) { // 存在表单DOM节点时优先取DOM节点数据
            formData = handle(options.$form, formData);
        } else { // 没有DOM节点时取formData数据
            formData = options.formData || {};
        }
    }
    !formData ? pop.alert('待提交的表单中无数据可提交') : ajax({
        trfOpt: { loading: '' },
        url:'/trffile/upload/submit',
        type: 'post',
        cache:false,
        contentType: false,
        processData: false,
        data: formData
    }).then(function(resp) {
        var error = resp.error || {};
        if(isDom || !options.needCallback) { // 若options为DOM节点 或 options中的needCallback为假
            if(error.code==0 || resp.data!=null) {
                pop.alert('上传成功');
            } else {
                pop.alert(error.msg || '上传失败');
            }
        } else {
            toStringFn.call(options.callback)==='[object Function]' && options.callback.call(this, resp);
        }
    });

    function handle($form, formData) {
        var hasName = true; // 上传文件时，type=file类型的input框都有name属性
        var $file;
        if(!!$form && !!$form.length) {
            $file = $form.find('input[type="file"]');
            $file.each(function() {
                if(!$(this).attr('name')) { // 若存在无name的input
                    hasName = false;
                }
            });
            if(!!$file.length && hasName) { // 有文件且文件都有name属性
                $form.attr('enctype', 'multipart/form-data');
                formData = new FormData($($form)[0]);
            } else {
                formData = undefined;
                pop.alert('type=file类型的input框必须有name属性，请检查后再提交');
            }
        } else {
            formData = undefined;
            throw Error('未找到$form节点');
        }
        return formData;
    }
}

/**
 * 下载文件
 * @param options 请求入参，string类型或者object类型，若string类型则表示查看，否则为下载
 * @returns {string}
 */
function downloadFile(options) {
    var toStringFn = Object.prototype.toString;
    var downloadType;
    var prefix = '/trffile/storage/'; // 固定路径：下载文件的固定前缀，后面跟文件名
    var path;
    if(toStringFn.call(options)==='[object String]') { // 若为字符串，则表示直接查看
        return prefix + options;
    } else {
        options = $.extend(true, {}, {
            fileName: '',
            downloadType: 'download', // 下载类型：preview：查看，download：下载
        }, options);
        downloadType = options.downloadType || '';
        path = prefix + options.fileName;
        if(downloadType == 'download') { // 下载
            window.open(path, '_blank');
        } else {
            return path;
        }
    }
}

module.exports = {
    uploadFile: uploadFile,
    downloadFile: downloadFile
};


//////////////////
// WEBPACK FOOTER
// ./src/components/upload-file.js
// module id = 194
// module chunks = 0